import { render } from "./CompanyItem.vue?vue&type=template&id=0c9f6f24&scoped=true"
import script from "./CompanyItem.vue?vue&type=script&lang=js"
export * from "./CompanyItem.vue?vue&type=script&lang=js"

import "./CompanyItem.vue?vue&type=style&index=0&id=0c9f6f24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9f6f24"]])

export default __exports__